import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  SetState,
  GetState,
} from '../../components/DailyAgenda/state/createState';
import { initServices } from './initServices/initServices';
import { initStaffMembers } from './initStaffMembers/initStaffMembers';
import { initSlots } from './initSlots/initSlots';
import { initAvailableDays } from './initAvailableDays/initAvailableDays';
import { initBookings } from './initBookings/initBookings';
import { AsyncComponentDataStatus } from '../../components/DailyAgenda/state/types';
import { DailyAgendaBiLogger } from '../../utils/bi/biLogger';

export type InitiatorsArgs = {
  flowAPI: ControllerFlowAPI;
  setState: SetState;
  getState: GetState;
  biLogger?: DailyAgendaBiLogger;
};

export const initWidgetData = (args: InitiatorsArgs) => {
  initServices(args);
  initSlots(args);
  initAvailableDays(args).then(() => {
    const { availableDays } = args.getState();
    if (availableDays.status === AsyncComponentDataStatus.IDLE) {
      args.biLogger?.reportDatePickerLoad();
    }
  });
  initStaffMembers(args);
  initBookings(args);
};
